const useStripTags = val => {
  return val.replace(/<\/?[^>]+(>|$)/g, '');
};
export default useStripTags;
//# sourceMappingURL=use-strip-tags.js.map